/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Search_ButtonInputs */

const en_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const fr_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const de_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen`)
};

const it_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca`)
};

const ru_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const es_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const zh_cn2_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const ja_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const hi_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज`)
};

const pt_pt2_find_replace_search_button = /** @type {(inputs: Find_Replace_Search_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Find_Replace_Search_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_search_button = /** @type {((inputs?: Find_Replace_Search_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Search_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_search_button(inputs)
	if (locale === "de") return de_find_replace_search_button(inputs)
	if (locale === "it") return it_find_replace_search_button(inputs)
	if (locale === "ru") return ru_find_replace_search_button(inputs)
	if (locale === "es") return es_find_replace_search_button(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_search_button(inputs)
	if (locale === "ja") return ja_find_replace_search_button(inputs)
	if (locale === "hi") return hi_find_replace_search_button(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_search_button(inputs)
	return en_find_replace_search_button(inputs)
});